/*** Please ensure this file is placed at the beginning of theme.liquid before any other js files ***/

/* p1Commerce - Send cylindoGA4Event dataLayer events to custom pixel GTM-M7G7NR3 [p1Commerce] */
(function () {
    window.dataLayer = window.dataLayer || [];

    // Intercept the dataLayer events to publish as a custom event
    (function (origPush) {
        window.dataLayer.push = function (...args) {
            for (const data of args) {
                if (data?.event === 'cylindoGA4Event') {
                    // Publish custom event to custom pixel
                    Shopify.analytics.publish('cylindoGA4Event', {
                        event: 'cylindoGA4Event',
                        cylindo: data
                    });
                }
            }
            return origPush.apply(this, args);
        };
    })(window.dataLayer.push);

})();